import React, { Component, Fragment } from "react";
import { Row, Card, Button, CardBody, FormGroup, Input, Label, CustomInput } from "reactstrap";
import IntlMessages from "../../../../helpers/IntlMessages";
import { Colxx, Separator } from "../../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../../containers/navs/Breadcrumb";
import DatePicker from "react-datepicker";
import { AvForm } from "availity-reactstrap-validation";

import { zeroPad, getCurrencySymbol } from "../../../../helpers/Utils";

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { Loader } from 'react-loaders';

import {REST_API_END_POINT,dataEncryptKey, LBS_CONSTANT, themeColor} from "../../../../constants/defaultValues";
import axios from 'axios';
import SimpleCrypto from "simple-crypto-js";
import moment from "moment";

import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-buttons-dt/css/buttons.dataTables.css';

var dataCrypto = new SimpleCrypto(dataEncryptKey);

const $ = require('jquery');
$.DataTable = require('datatables.net');
require( 'datatables.net-buttons/js/dataTables.buttons.min' );
const jzip = require( 'jszip');
require( 'pdfmake');
const pdfFonts = require( 'pdfmake/build/vfs_fonts');
require( 'datatables.net-buttons/js/buttons.html5.min' );
require( 'datatables.net-buttons/js/buttons.print.min' );

window.JSZip = jzip;
window.pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default class cashClose extends Component {
	
	constructor(props) {
		super(props);
		
		let currencySymbol = getCurrencySymbol(false);
		this.state = {		 
			reports:[],
			search: '',
			start_date: moment().startOf('day'),
			end_date: moment().endOf('day'),
			blocking: true,
			currencySymbol,
		};
		
		this.handleSubmit = this.handleSubmit.bind(this);
		this.dataListRender = this.dataListRender.bind(this);
		this.createDataTable = this.createDataTable.bind(this);
		this.makeArray = this.makeArray.bind(this);
	}
	
	handleChangeDate = date => {
		this.setState({
			start_date: date
		});
	}
	
	handleChangeEndDate = date => {
		this.setState({
			end_date: date
		});
	} 

	handleSubmit(event, errors, values) {
		if (errors.length === 0) {
			this.dataListRender();
		}
	}
     
	componentDidMount(){  
		this.dataListRender();		   
	}
    
	dataListRender() {
		this.setState({ blocking:true });
		
		var facility_id = localStorage.getItem('facility_id');
		facility_id =  dataCrypto.decrypt(facility_id);
        var formData = new FormData();
        formData.append('facility_id',facility_id);
		
		if(this.state.start_date!=null){
			formData.append('start_date',moment(this.state.start_date).format('YYYY-MM-DD HH:mm'));
		}else{
			formData.append('start_date','');
		}
		
		if(this.state.end_date!=null){
			formData.append('end_date',moment(this.state.end_date).format('YYYY-MM-DD HH:mm'));
		}else{
			formData.append('end_date','');
		}			
		
		axios.post(REST_API_END_POINT+'report/cash-close',formData).then((res)=>{
			var data = res.data;
			if(data.reports){
								
				this.setState({
					reports: data.reports,
					blocking:false
				},()=>{
					this.createDataTable();
				});
			}else{
				this.setState({
					reports: [],
					blocking:false
				},()=>{
					this.createDataTable();
				});
			}
				
        }).catch(e =>{
			console.log("Addition failed , Error ", e);
			this.setState({ blocking:false });
		});
	}
	
	createDataTable(){		
		this.$el = $(this.el);			
		this.$el.DataTable().clear().destroy();
		this.$el.DataTable({
				dom: 'Bfrtip',
				data: this.makeArray(),
				aaSorting:[],
				buttons: [
					{
						extend: 'csv',
						exportOptions: {
							columns: "thead th:not(.noExport)"
						}
					},
					{
						extend: 'excel',
						exportOptions: {
							columns: "thead th:not(.noExport)"
						}
					},
					{
						extend: 'pdf',
						exportOptions: {
							columns: "thead th:not(.noExport)"
						}
					},
					{
						extend: 'print',
						exportOptions: {
							columns: "thead th:not(.noExport)"
						}
					}
				]
			});
	}
	
	makeArray(){
		const reports = this.state.reports;
		var formated_data=[];
		var i=1;
		for(let row of reports){			
			formated_data.push([
				row.drawer_name,
				row.assigned_to,
				moment(row.assigned_at*1000).format('MM/DD/YYYY HH:mm'),
				moment(row.closed_at*1000).format('MM/DD/YYYY HH:mm'),
				this.state.currencySymbol+row.start_usd_amount,
				this.state.currencySymbol+row.usd_amount,
				this.state.currencySymbol+(parseFloat(row.overage_usd_amount)+parseFloat(row.shortage_usd_amount)>0 ? parseFloat(row.overage_usd_amount)+parseFloat(row.shortage_usd_amount):0.00),
				this.state.currencySymbol+(parseFloat(row.overage_usd_amount)+parseFloat(row.shortage_usd_amount)<0 ? -1*parseFloat(row.overage_usd_amount)+parseFloat(row.shortage_usd_amount):0.00),
				//"$"+row.start_usd_amount+"<br/>C$"+row.start_cad_amount+"<br/>J$"+row.start_jmd_amount,
				//"$"+row.usd_amount+"<br/>C$"+row.cad_amount+"<br/>J$"+row.jmd_amount,
				//"$"+(parseFloat(row.overage_usd_amount)+parseFloat(row.shortage_usd_amount)>0 ? parseFloat(row.overage_usd_amount)+parseFloat(row.shortage_usd_amount):0.00)+"<br/>C$"+(parseFloat(row.overage_cad_amount)+parseFloat(row.shortage_cad_amount)>0 ? parseFloat(row.overage_cad_amount)+parseFloat(row.shortage_cad_amount):0.00)+"<br/>J$"+(parseFloat(row.overage_jmd_amount)+parseFloat(row.shortage_jmd_amount)>0 ? parseFloat(row.overage_jmd_amount)+parseFloat(row.shortage_jmd_amount):0.00),
				//"$"+(parseFloat(row.overage_usd_amount)+parseFloat(row.shortage_usd_amount)<0 ? -1*parseFloat(row.overage_usd_amount)+parseFloat(row.shortage_usd_amount):0.00)+"<br/>C$"+(parseFloat(row.overage_cad_amount)+parseFloat(row.shortage_cad_amount)<0 ? -1*parseFloat(row.overage_cad_amount)+parseFloat(row.shortage_cad_amount):0.00)+"<br/>J$"+(parseFloat(row.overage_jmd_amount)+parseFloat(row.shortage_jmd_amount)<0 ? -1*parseFloat(row.overage_jmd_amount)+parseFloat(row.shortage_jmd_amount):0.00),
				'<a href="/app/reports/cash-close-detail/'+row.detail_id+'" class="btn btn-primary btn-sm" >View Detail</a>',
			])			
		}
		return formated_data;
	}
	
	
  
	render() {	
		const reports = this.state.reports;
		return (
			<Fragment>
				<Row>
					<Colxx xxs="12">
						<Breadcrumb heading="menu.cash-close" match={this.props.match} />
						<Separator className="mb-5" />
					</Colxx>
				</Row>
				<BlockUi tag="div" blocking={this.state.blocking} loader={<Loader active type="ball-scale-ripple-multiple" color={themeColor}/>}> 
					<Card className="p-4">				
						<AvForm
							className="av-tooltip tooltip-right-bottom"
							onSubmit={this.handleSubmit}
						>
						<Row>
							<Colxx lg="5">
								<Label>Start date<span className="text-danger">*</span></Label>
								<DatePicker
									id="start_date"
									name="start_date"
									className="mb-2"
									autoComplete="off"
									selected={this.state.start_date}
									onChange={this.handleChangeDate}
									showTimeSelect
									timeIntervals={30}
									placeholderText=""
									dateFormat="MM/DD/YYYY hh:mm a"
								/>
							</Colxx>
							
							<Colxx lg="5">
								<Label>End date<span className="text-danger">*</span></Label>
								<DatePicker
									id="end_date"
									name="end_date"
									className="mb-2"
									autoComplete="off"
									selected={this.state.end_date}
									onChange={this.handleChangeEndDate}
									showTimeSelect
									timeIntervals={30}
									placeholderText=""
									dateFormat="MM/DD/YYYY hh:mm a"
								/>
							</Colxx>
							<Colxx lg="2">
								<Label className="d-block">&nbsp;</Label>
								<Button	onClick={this.dataListRender} color="primary" size="sm" >View Report</Button>
							</Colxx>
						</Row>
						</AvForm> 	
						<Row className="mt-4">
							<Colxx xxs="12">
								<div className="mb-4 dropdown-edit">
									<table className="display table table-bordered table-striped" ref={el=>this.el=el} >
										<thead>
											<tr>				
												<th>Drawer Name</th>
												<th>Assigned to</th>
												<th>Assigned at</th>
												<th>Closed at</th>
												<th>Opening Amount</th>
												<th>Closing Amount</th>
												<th>Overages</th>
												<th>Shortages</th>
												<th className="noExport">Actions</th>
											</tr>
										</thead>
										<tbody></tbody>
									</table>
								</div>					
							</Colxx>
						</Row>
					</Card>
				</BlockUi>
			</Fragment>
		);
	}
}
